export const APP_AUTH_URL: string = process.env.APP_AUTH_URL || "http://localhost:8888";
